export default __webpack_public_path__ + "static/media/doc-img.ccc1b8a6.svg";